module.exports = __webpack_public_path__ + "media/images/favicon-32x32-3288fa1732388e62ff5c1100b5c99351.png";